var map = {
	"./kk/consultation-form.json": [
		1901,
		1901
	],
	"./kk/landings-info.json": [
		9356,
		9356
	],
	"./ru/consultation-form.json": [
		3922,
		3922
	],
	"./ru/landings-info.json": [
		5043,
		5043
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9512;
module.exports = webpackAsyncContext;